import React, { Component } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'recompose'
import CircularProgress from '@material-ui/core/CircularProgress'

import Input from '../../common/Input'
import DropDown from '../../common/DropDown'

import * as configActions from '../../actions/Config'
import * as bookingSystemActions from '../../actions/BookingSystems'
import * as Strings from './strings'

class EditBookingSystemModal extends Component {
  state = {
    errorMessage: '',
    nameInput: '',
    nameError: '',
    bookingRange: '',
    maxBookings: ''
  }

  componentWillReceiveProps(nextProps) {
    const { bookingSystems, config } = this.props
    const { nameInput } = this.state

    if (
      nextProps.config.editBookingSystemModal.show &&
      !config.editBookingSystemModal.show
    ) {
      this.setState({
        nameInput: nextProps.bookingSystems.selected.name,
        bookingRange: nextProps.bookingSystems.selected.bookingRange,
        maxBookings: nextProps.bookingSystems.selected.maxBookings,
        errorMessage: ''
      })
    }

    if (
      !nextProps.bookingSystems.isUpdating &&
      nextProps.bookingSystems.errorUpdating === null &&
      bookingSystems.isUpdating
    ) {
      this.props.hideEditBookingSystemModal()
      this.props.showSnackbar(nameInput + ' ' + Strings.default.UPDATED)
    } else if (
      !nextProps.bookingSystems.isUpdating &&
      nextProps.bookingSystems.errorUpdating !== null &&
      bookingSystems.isUpdating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  update() {
    const { nameInput, maxBookings, bookingRange } = this.state
    const { user, bookingSystems } = this.props

    this.setState({ errorMessage: '' })

    if (nameInput === '') {
      this.setState({ nameError: Strings.default.MANDATORY_FIELD })
    }

    if (nameInput !== '') {
      const postData = {
        name: nameInput,
        maxBookings,
        bookingRange
      }

      this.props.tryUpdateBookingSystem(
        user.token,
        bookingSystems.selected.id,
        postData
      )
    }
  }

  render() {
    const {
      errorMessage,
      nameInput,
      nameError,
      bookingRange,
      maxBookings
    } = this.state
    const { config, classes, bookingSystems } = this.props

    return (
      <Dialog
        open={config.editBookingSystemModal.show}
        aria-labelledby={'form-dialog-title'}
      >
        <DialogTitle id={'form-dialog-title'}>
          {Strings.default.EDIT_BOOKABLE_SYSTEM}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {Strings.default.EDIT_BOOKABLE_SYSTEM_INFO}
          </DialogContentText>
          {errorMessage === '' ? null : (
            <p style={{ fontSize: 12, color: '#e57373' }}>{errorMessage}</p>
          )}
          <Input
            placeholder={Strings.default.TITLE}
            value={nameInput}
            onChange={text =>
              this.setState({
                nameInput: text,
                nameError: '',
                errorMessage: ''
              })
            }
            error={nameError}
          />
          <DropDown
            placeholder={Strings.default.BOOKING_RANGE}
            options={[
              { value: 1, placeholder: '1 vecka framåt' },
              { value: 2, placeholder: '2 veckor framåt' },
              { value: 3, placeholder: '3 veckor framåt' },
              { value: 4, placeholder: '4 veckor framåt' },
              { value: 5, placeholder: '5 veckor framåt' },
              { value: 6, placeholder: '6 veckor framåt' },
              { value: 7, placeholder: '7 veckor framåt' },
              { value: 8, placeholder: '8 veckor framåt' },
              { value: 26, placeholder: '26 veckor framåt' },
              { value: 52, placeholder: '52 veckor framåt' },
              { value: 0, placeholder: 'Ingen gräns' }
            ]}
            value={bookingRange}
            onChange={value => this.setState({ bookingRange: value })}
          />
          <DropDown
            placeholder={Strings.default.MAX_BOOKINGS}
            options={[
              { value: 1, placeholder: '1 bokning åt gången' },
              { value: 2, placeholder: '2 bokningar åt gången' },
              { value: 3, placeholder: '3 bokningar åt gången' },
              { value: 4, placeholder: '4 bokningar åt gången' },
              { value: 5, placeholder: '5 bokningar åt gången' },
              { value: 6, placeholder: '6 bokningar åt gången' },
              { value: 7, placeholder: '7 bokningar åt gången' },
              { value: 8, placeholder: '8 bokningar åt gången' },
              { value: 9, placeholder: '9 bokningar åt gången' },
              { value: 10, placeholder: '10 bokningar åt gången' },
              { value: 11, placeholder: '11 bokningar åt gången' },
              { value: 12, placeholder: '12 bokningar åt gången' },
              { value: 13, placeholder: '13 bokningar åt gången' },
              { value: 14, placeholder: '14 bokningar åt gången' },
              { value: 15, placeholder: '15 bokningar åt gången' },
              { value: 16, placeholder: '16 bokningar åt gången' },
              { value: 17, placeholder: '17 bokningar åt gången' },
              { value: 18, placeholder: '18 bokningar åt gången' },
              { value: 19, placeholder: '19 bokningar åt gången' },
              { value: 20, placeholder: '20 bokningar åt gången' },
              { value: 0, placeholder: 'Ingen gräns' }
            ]}
            value={maxBookings}
            onChange={value => this.setState({ maxBookings: value })}
          />
        </DialogContent>
        {bookingSystems.isUpdating ? (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 15
            }}
          >
            <CircularProgress
              style={{ color: '#289e64' }}
              thickness={6}
              size={20}
            />
          </div>
        ) : (
          <DialogActions>
            <Button
              onClick={() => this.props.hideEditBookingSystemModal()}
              classes={{ label: classes.warningButtonText }}
            >
              {Strings.default.CANCEL}
            </Button>
            <Button
              onClick={() => this.update()}
              classes={{ label: classes.successButtonText }}
            >
              {Strings.default.DONE}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    )
  }
}

const Styles = {
  successButtonText: {
    color: '#289e64'
  },
  warningButtonText: {
    color: '#e57373'
  }
}

function mapStateToProps({ data, user, config, bookingSystems }) {
  return { data, user, config, bookingSystems }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...bookingSystemActions },
    dispatch
  )
}

export default compose(
  withStyles(Styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EditBookingSystemModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditBookingSystemModal/index.js